import styled, { keyframes } from 'styled-components';

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const appearBackground = keyframes`
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 10;
  animation: ${appearBackground} 0.5s;
  transition: ${appearBackground} 0.5s;

  .active {
    opacity: 1;
    top: 30%;
    visibility: visible;
    animation: ${appearFromTop} 0.4s;

    @media (max-width: 650px) {
      animation: ${appearFromTop} 0.4s;
    }
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  top: -500px;
  position: fixed;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  border-radius: 5px;
  width: 40%;
  height: 33%;
  padding: 20px 40px;
  visibility: hidden;
  transition: all 0.5s ease-out;

  h1 {
    font-weight: 500;
  }
  h2 {
    margin-left: 10px;
    color: #455a64;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
  width: 100%;
  margin-bottom: 10px;

  h1 {
    font-size: 22px;
    font-weight: 500;
  }
`;

export const ContentView = styled.div`
  display: flex;

  h2 {
    font-size: 16px;
    font-weight: 500;
  }
`;

export const ButtonsView = styled.div`
  display: flex;

  button:first-child {
    margin-right: 10px;
  }
`;
